import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Divider,
  Image,
  Button,
} from "@nextui-org/react";
import { courseType } from "../@types/course";
import { BaseUrl } from "../api";
import { toast } from "react-toastify";
import useCsrfToken from "../hooks/useCsrfToken";

const CourseCard = ({ course }: { course: courseType }) => {
  const [isRegistered, setIsRegistered] = useState(false);
  const { csrfToken } = useCsrfToken();

  const checkIsRegistered = async () => {
    try {
      const reg = JSON.parse(localStorage.getItem("StudentCourses") || "[]")
        .map((course: courseType) => course.code)
        .includes(course.code);
      setIsRegistered(reg);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkIsRegistered();
  }, []);

  const handelRegisterCourse = async (courseCode: string) => {
    try {
      console.log(csrfToken);
      const response = await fetch(`${BaseUrl}/courses/${courseCode}/`, {
        method: "POST",
        credentials: "include",
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      const data = await response.json();
      try {
        const response = await fetch(`${BaseUrl}/courses/std/`, {
          credentials: "include",
        });

        if (!response.ok) {
          console.log("error");
        }

        const data = await response.json();
        localStorage.setItem("StudentCourses", JSON.stringify(data.courses));
        checkIsRegistered();
      } catch (error) {
        toast.error("Failed to fetch courses");
      }
      if (data.message === "Course added successfully.") {
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error("Failed to register course");
    }
  };

  return (
    <Card className="max-w-[400px] hover:scale-105 cursor-pointer">
      <CardHeader className="flex gap-3">
        <Image
          alt="nextui logo"
          height={40}
          radius="sm"
          src="https://www.ppu.edu/p/sites/all/themes/ppu2018/logo.png"
          width={40}
        />
        <div className="flex flex-col">
          <p className="text-md">{course.name}</p>
          <p className="text-small text-default-500">{course.code}</p>
        </div>
      </CardHeader>
      <Divider />
      <CardBody>
        <p>{course.description}</p>
        <p>
          <span className="font-bold">Instructor: </span>
          {course.instructor}
        </p>
        <Divider className="mt-1" />
        <div className="flex gap-1 items-center justify-between pt-1">
          <div className="flex gap-2 flex-col">
            <span>Days: {course?.schedule_id?.days}</span>
            <span>Room: {course?.schedule_id?.room_no}</span>
          </div>
          <div className="flex gap-2 flex-col">
            <span>Start Time: {course?.schedule_id?.start_time}</span>
            <span>End Time: {course?.schedule_id?.end_time}</span>
          </div>
        </div>
        {course?.prerequisites && course?.prerequisites.length > 0 && (
          <div className="rounded-md bg-[#fdff95] py-1 px-2">
            <span className="text-yellow-500 font-bold">
              prerequisites:
              {course?.prerequisites.map((prerequisite) => (
                <span key={prerequisite.code} className="text-yellow-500">
                  {" "}
                  {prerequisite.name}
                </span>
              ))}
            </span>
          </div>
        )}
        <div className="mt-2">
          <span
            className={`text-small text-default-500 px-2 py-1 rounded-md ${
              course.capacity === course.numberOfRegistered
                ? "bg-red-400 text-white"
                : "bg-green-400 text-white"
            }`}
          >
            Capacity: {course.capacity} :{" "}
            {course.numberOfRegistered > 0 ? course.numberOfRegistered : 0}{" "}
          </span>
        </div>
      </CardBody>
      <Divider />
      <CardFooter>
        <Button
          variant="flat"
          color="primary"
          disabled={isRegistered}
          className={`${
            isRegistered || course.capacity === course.numberOfRegistered
              ? "cursor-not-allowed bg-slate-300 text-slate-800"
              : ""
          }`}
          onClick={() => handelRegisterCourse(course.code)}
        >
          {isRegistered ? "Registered" : "Register"}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default CourseCard;
